import { t } from "@lingui/core/macro";
import { TIER_LIMIT_CODES, tierLimitData } from "@rakazo/contracts";

/** The one line shown when a computer mode has no room on the person's plan. */
export function slotUnavailableText(why: "none" | "full"): string {
  return why === "none" ? t`Needs a higher plan.` : t`All in use on your plan.`;
}

/** A plain line for a plan refusal that still reached the client, or undefined for other errors. */
export function tierLimitErrorText(error: unknown): string | undefined {
  const data = tierLimitData(error);
  if (!data || data.code === TIER_LIMIT_CODES.mixedGroup) return undefined;
  return slotUnavailableText(data.limit === 0 ? "none" : "full");
}
